import { render, staticRenderFns } from "./ReorderReportDetail.vue?vue&type=template&id=436488b9&scoped=true"
import script from "./ReorderReportDetail.vue?vue&type=script&lang=js"
export * from "./ReorderReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ReorderReportDetail.vue?vue&type=style&index=0&id=436488b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436488b9",
  null
  
)

export default component.exports